import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const FileIconSvg = () => (
  <svg
    width="24"
    height="48"
    viewBox="0 0 38 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.9997 47.3327C34.2374 47.3327 35.4243 46.841 36.2995 45.9659C37.1747 45.0907 37.6663 43.9037 37.6663 42.666V14.666L23.6663 0.666016H4.99967C3.762 0.666016 2.57501 1.15768 1.69984 2.03285C0.824673 2.90802 0.333008 4.09501 0.333008 5.33268V42.666C0.333008 43.9037 0.824673 45.0907 1.69984 45.9659C2.57501 46.841 3.762 47.3327 4.99967 47.3327H32.9997ZM21.333 5.33268L32.9997 16.9993H21.333V5.33268ZM7.33301 14.666H14.333V19.3327H7.33301V14.666ZM7.33301 23.9994H30.6663V28.666H7.33301V23.9994ZM7.33301 33.3327H30.6663V37.9994H7.33301V33.3327Z"
      fill="#929191"
    />
  </svg>
);

export const FileIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={FileIconSvg} {...props} />
);

export default FileIcon;

FileIcon.displayName = "FileIcon";
